<ol class="breadcrumb">
    <breadcrumbs></breadcrumbs>
</ol>
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <wj-tab-panel #orderTabPanel [selectedIndex]="0">
                <wj-tab>
                    <a>検索</a>
                    <div class="card">
                        <div class="card-header">
                            検索
                        </div>
                        <div class="card-body">
                            <div class="form-group row">
                                <label class="col-md-3 form-control-label d-none d-lg-block">日付</label>
                                <div class="col-md-3">
                                    <wj-input-date style="width:100%;" style="width:100%;" [(value)]="fromDate"
                                                   [format]="'yyyy/MM/dd'" [isRequired]="false"
                                                   [placeholder]="'から'"></wj-input-date>
                                </div>
                                <div class="col-md-3">
                                    <wj-input-date style="width:100%;" style="width:100%;" [(value)]="toDate"
                                                   [format]="'yyyy/MM/dd'" [isRequired]="false"
                                                   [placeholder]="'まで'"></wj-input-date>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 form-control-label d-none d-lg-block">検索</label>
                                <div class="col-md-3">
                                    <wj-combo-box style="width:100%;" [itemsSource]="['お名前(全角カタカナ)','住所','電話番号','買取区分','複数項目']"
                                                  [(ngModel)]="keyProperty" [isEditable]="false"
                                                  [isRequired]="true"></wj-combo-box>
                                </div>
                                <div class="col-md-3" (keyup.enter)="search()">
                                    <input type="text" [(ngModel)]="keyword" class="form-control" placeholder="検索">
                                </div>
                                <div class="col-md-3">
                                    <button (click)="search()" class="btn btn-primary btn-block">検索</button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <wj-multi-row *ngIf="screenWidth >= 768" #orderGrid [isReadOnly]="true" [selectionMode]="'Row'"
                                                  style="height:500px" [itemsSource]="orders" (dblclick)="mode = 'view';onCurrentChanged();orderTabPanel.selectedIndex = 1;mode = 'edit';">
                                        <wj-multi-row-cell-group>
                                            <wj-multi-row-cell binding='id' [header]="'番号'" [dataType]="'Number'" [width]="80">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                        <wj-multi-row-cell-group>
                                            <wj-multi-row-cell binding='branch' [header]="'枝番'" [dataType]="'Number'" [width]="80">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                        <wj-multi-row-cell-group>
                                            <wj-multi-row-cell binding='status' [header]="'買取区分'" [width]="100">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                        <wj-multi-row-cell-group>
                                            <wj-multi-row-cell binding='finalStatus' [header]="'最終区分'" [width]="100">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                        <wj-multi-row-cell-group>
                                            <wj-multi-row-cell binding='department' [header]="'部門'" [width]="100">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                        <wj-multi-row-cell-group>
                                            <wj-multi-row-cell binding='name' [header]="'お名前(全角カタカナ)'" [width]="160">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                        <wj-multi-row-cell-group>
                                            <wj-multi-row-cell binding='nameKanji' [header]="'お名前(漢字)'" [width]="160">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                        <wj-multi-row-cell-group>
                                            <wj-multi-row-cell binding='orderDate' [header]="'受付日'" [dataType]="'Date'" [format]="'yyyy/MM/dd'" [width]="100">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                        <wj-multi-row-cell-group>
                                            <wj-multi-row-cell binding='startDate' [header]="'買取日時'" [dataType]="'Date'" [format]="'yyyy/MM/dd HH:mm'" [width]="120">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                        <wj-multi-row-cell-group>
                                            <wj-multi-row-cell binding='endDate' [header]="'買取日時'" [dataType]="'Date'" [format]="'yyyy/MM/dd HH:mm'" [width]="120">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                        <wj-multi-row-cell-group>
                                            <wj-multi-row-cell binding='staff' [header]="'担当者'" [width]="160">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                        <wj-multi-row-cell-group>
                                            <wj-multi-row-cell binding='estimateStaff' [header]="'見積担当者'" [width]="160">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                        <wj-multi-row-cell-group>
                                            <wj-multi-row-cell binding='address' [header]="'住所'" [width]="200">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                        <wj-multi-row-cell-group>
                                            <wj-multi-row-cell binding='total' [header]="'合計金額'" [dataType]="'Number'" [width]="80">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                    </wj-multi-row>
                                    <wj-multi-row *ngIf="screenWidth < 768" #orderGrid [isReadOnly]="true" [selectionMode]="'Row'"
                                                  style="height:500px" [itemsSource]="orders" (dblclick)="mode = 'view';onCurrentChanged();orderTabPanel.selectedIndex = 1;mode = 'edit';">
                                        <wj-multi-row-cell-group>
                                            <wj-multi-row-cell binding='id' [header]="'番号'" [dataType]="'Number'" [width]="60" [rowspan]="2">
                                            </wj-multi-row-cell>
                                            <wj-multi-row-cell binding='branch' [header]="'枝番'" [dataType]="'Number'" [width]="60">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                        <wj-multi-row-cell-group [colspan]="3">
                                            <wj-multi-row-cell binding='status' [header]="'買取区分'" [width]="80">
                                            </wj-multi-row-cell>
                                            <wj-multi-row-cell binding='finalStatus' [header]="'最終区分'" [width]="80">
                                            </wj-multi-row-cell>
                                            <wj-multi-row-cell binding='name' [header]="'お名前'" [width]="120">
                                            </wj-multi-row-cell>
                                            <wj-multi-row-cell binding='orderDate' [header]="'受付日'" [dataType]="'Date'" [format]="'MM/dd'">
                                            </wj-multi-row-cell>
                                            <wj-multi-row-cell binding='startDate' [header]="'買取日時'" [dataType]="'Date'" [format]="'MM/dd HH:mm'">
                                            </wj-multi-row-cell>
                                            <wj-multi-row-cell binding='total' [header]="'合計金額'" [dataType]="'Number'">
                                            </wj-multi-row-cell>
                                            <wj-multi-row-cell binding='address' [header]="'住所'" [colspan]="3">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                    </wj-multi-row>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <button (click)="export('orderGrid','買取情報')" class="btn btn-primary btn-block">エクスポート
                            </button>
                        </div>
                    </div>
                </wj-tab>
                <wj-tab>
                    <a>買取情報(<span *ngIf="orderHead['@rid'] == '#-1:-1'">新規</span><span *ngIf="orderHead.id > 0">{{orderHead.id}}</span>-{{orderHead.branch}})</a>
                    <div class="card">
                        <div class="card-header">
                            <div class="row">
                                <div [hidden]="mode=='edit'|| orderLine.items.length == 0" class="col-md-2 col-6 order-p">
                                    <button (click)="printPDF('見積書(58mm)')" type="button"
                                            class="btn btn-block btn-success">見積書58mm/Quotation 58mm
                                    </button>
                                </div>
                                <div [hidden]="mode=='edit'|| !hasSign || orderLine.items.length == 0" class="col-md-2 col-6 order-p">
                                    <button (click)="printPDF('買取明細書(58mm)')" type="button"
                                            class="btn btn-block btn-success">買取明細書58mm/Purchase Statement 58mm
                                    </button>
                                </div>
                                <div [hidden]="mode=='edit'|| orderLine.items.length == 0" class="col-md-2 col-6 order-p">
                                    <button (click)="generatePDF('見積書')" type="button"
                                            class="btn btn-block btn-success">見積書PDF/Quotation PDF
                                    </button>
                                </div>
                                <div [hidden]="mode=='edit'|| !hasSign || orderLine.items.length == 0" class="col-md-2 col-6 order-p">
                                    <button (click)="generatePDF('買取明細書')" type="button"
                                            class="btn btn-block btn-success">買取明細書PDF/Purchase Statement PDF
                                    </button>
                                </div>
                                <div class="col-md-2 col-6 order-p">
                                    <button [disabled]="orderHead['@rid'] == '#-1:-1'" (click)="signModal.show()"
                                            class="btn btn-primary btn-block">署名/Sign
                                    </button>
                                </div>
                                <div [hidden]="!hasSign" class="col-md-2 col-6 order-p">
                                    <button [disabled]="orderHead['@rid'] == '#-1:-1'" (click)="removeSignPopup.show()"
                                            class="btn btn-danger btn-block">署名削除/Delete Sign
                                    </button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-2 col-6 order-p">
                                    <button (click)="mode = 'edit';createNew()" type="button"
                                            class="btn btn-block btn-primary">新規作成/New
                                    </button>
                                </div>
                                <div class="col-md-2  col-6 order-p">
                                    <button [disabled]="orderHead['@rid'] == '#-1:-1'" (click)="mode = 'edit';copyNew()" type="button"
                                            class="btn btn-block btn-primary">コピー/Copy
                                    </button>
                                </div>
                                <div class="col-md-2 col-6 order-p">
                                    <button [disabled]="orderHead['@rid'] == '#-1:-1'" (click)="mode = 'edit'"
                                            type="button" class="btn btn-block btn-primary">編集/Edit
                                    </button>
                                </div>
                                <div class="col-md-2 col-6 order-p">
                                    <button [disabled]="orderHead['@rid'] == '#-1:-1'" (click)="confirmRemoveOrder()"
                                            type="button" class="btn btn-block btn-danger">削除/Delete
                                    </button>
                                </div>
                                <div [hidden]="!canSyncEvent() || orderHead['@rid'] == '#-1:-1'" class="col-md-2 col-6 order-p">
                                    <button (click)="syncEvent()" type="button" class="btn btn-block btn-info">カレンダー同期/Sync Calendar</button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body" ybAddress [ybAutocompleteMode]="'off'" #address="ybAddress">
                            <fieldset [disabled]="mode == 'view'">
                                <div class="form-group row">
                                    <label class="col-md-3 form-control-label d-none d-lg-block">受付日/Reception Date</label>
                                    <div class="col-md-3">
                                        <wj-input-date style="width:100%;" style="width:100%;"
                                                       [(value)]="orderHead.orderDate" [format]="'yyyy/MM/dd'"
                                                       [isRequired]="false"
                                                       [placeholder]="'受付日'"></wj-input-date>
                                    </div>
                                </div>
                                <div class="form-group row" [hidden]="isAbroad()">
                                    <label class="col-md-3 form-control-label d-none d-lg-block">郵便番号</label>
                                    <div class="col-md-6" (keyup.enter)="address.complete()"><input type="text" [(ngModel)]="orderHead.postalCode" class="form-control" placeholder="郵便番号" ybPostalCode></div>
                                    <div class="col-md-3">
                                        <button (click)="address.complete()" class="btn btn-primary btn-block">住所入力
                                        </button>
                                    </div>
                                </div>
                                <div class="form-group row" [hidden]="isAbroad()">
                                    <label class="col-md-3 form-control-label d-none d-lg-block">都道府県</label>
                                    <div class="col-md-9">
                                        <input type="text" [(ngModel)]="orderHead.state" class="form-control" placeholder="都道府県" ybRegion>
                                    </div>
                                </div>
                                <div class="form-group row" [hidden]="isAbroad()">
                                    <label class="col-md-3 form-control-label d-none d-lg-block">市区町村</label>
                                    <div class="col-md-9">
                                        <input type="text" [(ngModel)]="orderHead.city" class="form-control" placeholder="市区町村" ybLocality>
                                    </div>
                                </div>
                                <div class="form-group row" [hidden]="isAbroad()">
                                    <label class="col-md-3 form-control-label d-none d-lg-block">町名</label>
                                    <div class="col-md-9">
                                        <input type="text" [(ngModel)]="orderHead.street" class="form-control" placeholder="町名" ybStreet>
                                    </div>
                                </div>
                                <div class="form-group row" [hidden]="isAbroad()">
                                    <label class="col-md-3 form-control-label d-none d-lg-block">建物</label>
                                    <div class="col-md-9">
                                        <input type="text" [(ngModel)]="orderHead.building" class="form-control" placeholder="建物" ybExtended>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-3 form-control-label d-none d-lg-block">商品検索/Search Product</label>
                                    <div class="col-md-3">
                                        <wj-auto-complete #findProduct style="width:100%;" [placeholder]="'商品検索'" [displayMemberPath]="'display'" [itemsSourceFunction]="getProduct"></wj-auto-complete>
                                    </div>
                                    <div class="col-md-2">
                                        <button [disabled]="!hasProduct()" (click)="addProduct()" class="btn btn-primary btn-block">商品追加/Add Product</button>
                                    </div>
                                    <div class="col-md-2">
                                        <button (click)="addCarryOutFee()" class="btn btn-primary btn-block">搬出手数料追加/Add Fee</button>
                                    </div>
                                    <div class="col-md-2">
                                        <button *ngIf="mode == 'edit'" (click)="deleteOrderLine()" class="btn btn-danger btn-block">明細行削除/Delete Line)</button>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <wj-multi-row *ngIf="screenWidth >= 768" #orderLineGrid [isReadOnly]="mode == 'view'" [allowAddNew]="true"
                                                      [allowDelete]="true"
                                                      [itemsSource]="orderLine">
                                            <wj-multi-row-cell-group>
                                                <wj-multi-row-cell binding='productName' [header]="'商品名'" [width]="160" [isRequired]="false">
                                                </wj-multi-row-cell>
                                            </wj-multi-row-cell-group>
                                            <wj-multi-row-cell-group>
                                                <wj-multi-row-cell binding='manufactureName' [header]="'メーカー'" [width]="160" [isRequired]="false">
                                                </wj-multi-row-cell>
                                            </wj-multi-row-cell-group>
                                            <wj-multi-row-cell-group>
                                                <wj-multi-row-cell binding='modelNumber' [header]="'型番'" [width]="160" [isRequired]="false">
                                                </wj-multi-row-cell>
                                            </wj-multi-row-cell-group>
                                            <wj-multi-row-cell-group>
                                                <wj-multi-row-cell binding='quantity' [header]="'数量'" [dataType]="'Number'" [width]="80">
                                                </wj-multi-row-cell>
                                            </wj-multi-row-cell-group>
                                            <wj-multi-row-cell-group>
                                                <wj-multi-row-cell binding='unit' [header]="'単位'" [width]="40" [isRequired]="false">
                                                </wj-multi-row-cell>
                                            </wj-multi-row-cell-group>
                                            <wj-multi-row-cell-group>
                                                <wj-multi-row-cell binding='price' [header]="'単価'" [dataType]="'Number'" [width]="80">
                                                </wj-multi-row-cell>
                                            </wj-multi-row-cell-group>
                                            <wj-multi-row-cell-group>
                                                <wj-multi-row-cell binding='amount' [header]="'金額'" [dataType]="'Number'" [width]="80" [isReadOnly]="true">
                                                </wj-multi-row-cell>
                                            </wj-multi-row-cell-group>
                                            <wj-multi-row-cell-group>
                                                <wj-multi-row-cell binding='oversea' [header]="'海外'" [width]="100" [isRequired]="false">
                                                    <ng-template wjMultiRowCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                                                        <wj-combo-box class="cell-editor" [itemsSource]="['','BB仕入']" [(selectedValue)]="cell.value" [isEditable]="false" [isRequired]="false"></wj-combo-box>
                                                    </ng-template>
                                                </wj-multi-row-cell>
                                            </wj-multi-row-cell-group>
                                            <wj-multi-row-cell-group>
                                                <wj-multi-row-cell binding='memo' [header]="'備考'" [width]="320" [isRequired]="false"></wj-multi-row-cell>
                                            </wj-multi-row-cell-group>
                                        </wj-multi-row>
                                        <wj-multi-row *ngIf="screenWidth < 768" #orderLineGrid [isReadOnly]="mode == 'view'" [allowAddNew]="true" [allowDelete]="true" [itemsSource]="orderLine">
                                            <wj-multi-row-cell-group [colspan]="3">
                                                <wj-multi-row-cell binding='productName' [header]="'商品名'" [width]="100" [colspan]="2" [isRequired]="false">
                                                </wj-multi-row-cell>
                                                <wj-multi-row-cell binding='manufactureName' [header]="'メーカー'" [width]="100" [isRequired]="false">
                                                </wj-multi-row-cell>
                                                <wj-multi-row-cell binding='modelNumber' [header]="'型番'" [isRequired]="false">
                                                </wj-multi-row-cell>
                                                <wj-multi-row-cell binding='unit' [header]="'単位'" [isRequired]="false">
                                                </wj-multi-row-cell>
                                                <wj-multi-row-cell binding='oversea' [header]="'海外'" [width]="100" [isRequired]="false">
                                                    <ng-template wjMultiRowCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                                                        <wj-combo-box class="cell-editor" [itemsSource]="['','BB仕入']" [(selectedValue)]="cell.value" [isEditable]="false" [isRequired]="false"></wj-combo-box>
                                                    </ng-template>
                                                </wj-multi-row-cell>
                                                <wj-multi-row-cell binding='quantity' [header]="'数量'" [dataType]="'Number'">
                                                </wj-multi-row-cell>
                                                <wj-multi-row-cell binding='price' [header]="'単価'" [dataType]="'Number'">
                                                </wj-multi-row-cell>
                                                <wj-multi-row-cell binding='amount' [header]="'金額'" [dataType]="'Number'" [isReadOnly]="true">
                                                </wj-multi-row-cell>
                                                <wj-multi-row-cell binding='memo' [header]="'備考'" [colspan]="3" [isRequired]="false">
                                                </wj-multi-row-cell>
                                            </wj-multi-row-cell-group>
                                        </wj-multi-row>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-3 form-control-label d-none d-lg-block">メモ/Memo</label>
                                    <div class="col-md-9">
                                        <textarea type="text" [(ngModel)]="orderHead.memo" class="form-control" placeholder="メモ"></textarea>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-3 form-control-label d-none d-lg-block">お名前(全角カタカナ)/Name Katakana</label>
                                    <div class="col-md-9">
                                        <input type="text" [(ngModel)]="orderHead.name" class="form-control" placeholder="お名前(全角カタカナ)">
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-3 form-control-label d-none d-lg-block">お名前(漢字)/Name Kanji</label>
                                    <div class="col-md-9">
                                        <input type="text" [(ngModel)]="orderHead.nameKanji" class="form-control" placeholder="お名前(漢字)">
                                    </div>
                                </div>
                                <div class="form-group row" [hidden]="isAbroad()">
                                    <label class="col-md-3 form-control-label d-none d-lg-block">生年月日</label>
                                    <div class="col-md-3">
                                        <wj-input-date style="width:100%;" #birthDayInput [(value)]="orderHead.birthDay" [isRequired]="false" [placeholder]="'生年月日'"></wj-input-date>
                                    </div>
                                    <label class="col-md-3 form-control-label">和暦</label>
                                    <div class="col-md-3">
                                        <input type="checkbox" class="form-control" (change)="onChangeJapanDate()" [(ngModel)]="orderHead.japanDate" [ngModelOptions]="{standalone: true}" placeholder="和暦">
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-3 form-control-label d-none d-lg-block">身分証明</label>
                                    <div class="col-md-9">
                                        <wj-combo-box style="width:100%;" [itemsSource]="['免許書','保険証', '住民票写し','']"
                                                      [(ngModel)]="orderHead.identityType" [isEditable]="true"
                                                      [isRequired]="false"></wj-combo-box>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-3 form-control-label d-none d-lg-block">身分証明番号</label>
                                    <div class="col-md-9">
                                        <input type="text" [(ngModel)]="orderHead.identityNumber" class="form-control" placeholder="身分証明番号">
                                    </div>
                                </div>
                                <div class="form-group row" [hidden]="isAbroad()">
                                    <label class="col-md-3 form-control-label d-none d-lg-block">電話番号</label>
                                    <div class="col-md-9">
                                        <input type="text" [(ngModel)]="orderHead.telephone" class="form-control" placeholder="電話番号" ybRegion>
                                    </div>
                                </div>
                                <div class="form-group row" [hidden]="isAbroad()">
                                    <label class="col-md-3 form-control-label d-none d-lg-block">携帯番号</label>
                                    <div class="col-md-9">
                                        <input type="text" [(ngModel)]="orderHead.mobile" class="form-control" placeholder="携帯番号" ybRegion>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-3 form-control-label d-none d-lg-block">買取開始日時/Purchase Start Datetime</label>
                                    <div class="col-md-3">
                                        <wj-input-date-time style="width:100%;" #startDateInput (valueChanged)="onChangeStartDate()" [(value)]="orderHead.startDate" [format]="'yyyy/MM/dd HH:mm'" [isRequired]="false" [placeholder]="'買取開始日時'" [timeMin]="timeMin" [timeStep]="30"></wj-input-date-time>
                                    </div>
                                    <label class="col-md-3 form-control-label d-none d-lg-block">買取終了日時/Purchase End Datetime</label>
                                    <div class="col-md-3">
                                        <wj-input-date-time style="width:100%;" #endDateInput [(value)]="orderHead.endDate" [format]="'yyyy/MM/dd HH:mm'" [isRequired]="false" [placeholder]="'買取終了日時'" [timeMin]="timeMin" [timeStep]="30"></wj-input-date-time>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-3 form-control-label d-none d-lg-block">担当者/Person in Charge</label>
                                    <div class="col-md-3">
                                        <wj-combo-box style="width:100%;" [itemsSource]="staffs" [(ngModel)]="orderHead.staff" [isEditable]="true" [isRequired]="false"></wj-combo-box>
                                    </div>
                                    <label class="col-md-3 form-control-label">見積担当者/Estimate Person</label>
                                    <div class="col-md-3">
                                        <wj-combo-box style="width:100%;" [itemsSource]="staffs" [(ngModel)]="orderHead.estimateStaff" [isEditable]="true" [isRequired]="false"></wj-combo-box>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-3 form-control-label d-none d-lg-block">買取区分/Purchase Type</label>
                                    <div class="col-md-3">
                                        <select class="form-control" [(ngModel)]="orderHead.status">
                                            <option *ngFor="let item of classifications" [value]="item.value" [hidden]="isAbroad() && item.value != '買取'">{{ item.value }}</option>
                                        </select>
                                    </div>
                                    <label class="col-md-3 form-control-label">非同期/Non Sync</label>
                                    <div class="col-md-3">
                                        <input type="checkbox" class="form-control" [(ngModel)]="orderHead.abroad" [ngModelOptions]="{standalone: true}" placeholder="非同期">
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-3 form-control-label d-none d-lg-block">最終区分/Final Status</label>
                                    <div class="col-md-9">
                                        <select class="form-control" [(ngModel)]="orderHead.finalStatus">
                                            <option *ngFor="let item of finalClassifications"
                                                    [value]="item.value">{{ item.value }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-3 form-control-label d-none d-lg-block">部門/Department</label>
                                    <div class="col-md-9">
                                        <select class="form-control" [(ngModel)]="orderHead.department" (change)="changeDepartment($event)">
                                            <option *ngFor="let item of departments" [value]="item.value">{{ item.value }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-3 form-control-label d-none d-lg-block">合計金額/Total Amount</label>
                                    <div class="col-md-9">
                                        {{orderHead.total| currency : 'JPY': true}}
                                        (消費税: {{orderHead.tax| currency : 'JPY': true}})
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                        <div class="card-footer">
                            <button *ngIf="mode == 'edit'" (click)="saveOrder()"
                                    class="btn btn-primary btn-block">保存/Save
                            </button>
                            <button *ngIf="mode == 'edit'" (click)="mode = 'view'; toTopOrder();"
                                    class="btn btn-block btn-danger">キャンセル/Cancel
                            </button>
                        </div>
                    </div>
                </wj-tab>
            </wj-tab-panel>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-footer">
                    <div style="float:left; min-width: 150px;">
                        <wj-menu [(value)]="orders.pageSize" [header]="'ページサイズ'">
                            <wj-menu-item [value]="100">100</wj-menu-item>
                            <wj-menu-item [value]="500">500</wj-menu-item>
                            <wj-menu-item [value]="1000">1000</wj-menu-item>
                        </wj-menu>
                    </div>
                    <div style="float:left; min-width: 150px;">
                        <wj-collection-view-navigator [cv]="orders"></wj-collection-view-navigator>
                    </div>
                    <div style="float:left; min-width: 150px;">
                        <wj-collection-view-pager [cv]="orders"></wj-collection-view-pager>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<cb-modal-confirm #removeOrderPopup (onConfirm)="removeOrder()" [modalClass]="'modal-danger'" [closeButton]="'キャンセル'"
                  [confirmButton]="'削除'" [title]="'削除'"
                  [content]="'本当に' + orderHead.id + 'を削除しますか？'"></cb-modal-confirm>
<cb-modal-confirm #removeSignPopup (onConfirm)="removeSign()" [modalClass]="'modal-danger'" [closeButton]="'キャンセル'"
                  [confirmButton]="'削除'" [title]="'削除'"
                  [content]="'本当に' + orderHead.id + 'の署名を削除しますか？'"></cb-modal-confirm>

<div bsModal #signModal="bs-modal" class="modal fad" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" style="width:428px; height: 320px;" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">署名</h4>
                <button type="button" class="close" (click)="signModal.hide()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ng-whiteboard #whiteboard style="width:400px;height: 160px;"></ng-whiteboard>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-info" (click)="saveSign()">保存/Save</button>
                <button type="button" class="btn btn-success" (click)="whiteboard.undoDraw()">元に戻す/Undo</button>
                <button type="button" class="btn btn-primary" (click)="whiteboard.redoDraw()">繰り返し/Redo</button>
                <button type="button" class="btn btn-danger" (click)="whiteboard.eraseSvg()">クリア/Clear</button>
                <button type="button" class="btn btn-secondary" (click)="signModal.hide()">閉じる/Close</button>
            </div>
        </div>
    </div>
</div>
